import PropTypes from 'prop-types';

import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import { Badge, Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useTransl } from 'shared/lib/i18n';

const CommunityMembersButton = (props) => {
  const { t } = useTransl();
  const theme = useTheme();
  const { onClick, count } = props;
  return (
    <Button
      disableElevation
      fullWidth
      onClick={onClick}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginLeft: '-1rem',
      }}
    >
      <Box display="flex" gap="1rem">
        <PeopleOutlineIcon sx={{ color: theme.palette.custom.purple }} />
        <Typography color={theme.palette.text.primary}>
          {t('community.myCommunityMembers')}
        </Typography>
      </Box>

      {Boolean(count) && (
        <Badge
          badgeContent={count}
          color="primary"
          sx={{ marginRight: '1rem' }}
        />
      )}
    </Button>
  );
};

CommunityMembersButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  count: PropTypes.number,
};

export default CommunityMembersButton;
